var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadToFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1331 34.1H33.0664V36.1667H35.1331V34.1Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1331 29.9667H33.0664V32.0333H35.1331V29.9667Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1331 25.8333H33.0664V27.9H35.1331V25.8333Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2666 12.4V10.3333",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2666 16.5333V14.4667",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2666 20.6667V18.6",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9333 4.13333V32.0333H25.2308C24.4228 32.0333 23.7666 32.6885 23.7666 33.4965C23.7666 33.884 23.9226 34.255 24.1965 34.5299L32.336 42.6694C32.8041 43.1375 33.4386 43.4 34.0999 43.4C34.7623 43.4 35.3957 43.1375 35.8638 42.6694L44.0034 34.5299C44.2783 34.255 44.4343 33.8809 44.4333 33.4924C44.4312 32.6864 43.775 32.0333 42.969 32.0333H39.2666V22.7333",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30007 22.7333H7.2334V24.8H9.30007V22.7333Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4329 22.7333H11.3662V24.8H13.4329V22.7333Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 22.7333H15.5V24.8H17.5667V22.7333Z",
    fill: "#002145",
    fillOpacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4326 15.4667V19.6",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4326 1.06667V11.4",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7666 12.4V6.2",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5664 54.7667H36.1664",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2334 54.7666H46.4334",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3663 23.7667H56.3163C57.7433 23.7667 58.8996 24.923 58.8996 26.35C58.8996 26.4709 58.8913 26.5897 58.8748 26.7065L54.7415 56.6732C54.5679 57.9307 53.4891 58.9 52.1829 58.9H10.8496C9.55071 58.9 8.47604 57.9421 8.29314 56.6938V56.6959L3.12648 21.5605C3.10891 21.4375 3.09961 21.3115 3.09961 21.1833C3.09961 19.7563 4.25591 18.6 5.68294 18.6H16.7107C17.2583 18.6 17.7843 18.818 18.1718 19.2055L22.1274 23.1611C22.5149 23.5486 23.0409 23.7667 23.5885 23.7667H25.8329",
    stroke: "#002145",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadToFolderIcon);
export default __webpack_public_path__ + "static/media/download_to_folder_icon.756291cb6af426b168882d5dc0b9d116.svg";
export { ForwardRef as ReactComponent };